import db from '../../plugins/firebase'
import { collection, query, getDocs, addDoc, updateDoc, doc, where } from "firebase/firestore"

const filterAll = async (filter) => {
  const entradasRef = collection(db, "entradas");
  const params = []
  const entradaList = []
  if(filter && filter.periodos && filter.periodos.length)
    params.push(where("data_entrada", "in", filter.periodos))

  if (filter.idPessoa) {
    params.push(where("pessoa.id", "==", filter.idPessoa))
  }
  if (filter.idObra) {
    params.push(where("obra.id", "==", filter.idObra))
  }

  params.push(where("active", "==", true))
  const q = query(entradasRef, ...params);

  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    entradaList.push({
      id: doc.id,
      ...doc.data()
    })
  });
  return entradaList
}

const getBalanco = async (filter) => {
  const entradasRef = collection(db, "entradas");
  const params = []
  const entradaList = []
  if (filter.idPessoa) {
    params.push(where("pessoa.id", "==", filter.idPessoa))
  }
  if (filter.idObra) {
    params.push(where("obra.id", "==", filter.idObra))
  }

  params.push(where("active", "==", true))
  const q = query(entradasRef, ...params);

  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    entradaList.push({
      id: doc.id,
      ...doc.data()
    })
  });
  return entradaList
}

const getAllEntradas = async () => {
  const entradasRef = collection(db, "entradas");
  const params = []
  const entradaList = []
  params.push(where("active", "==", true))
  const q = query(entradasRef, ...params);

  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    entradaList.push({
      ...doc.data()
    })
  });
  return entradaList
}

const saveEntrada = async (payload) => {
  const colRef = collection(db, 'entradas')
  await addDoc(colRef, payload)
}

const updateEntrada = async (payload) => {
  const colRef = await doc(db, 'entradas', payload.id);
  await updateDoc(colRef, payload);
}

const deleteEntrada = async (payload) => {
  const colRef = await doc(db, 'entradas', payload.id);
  await updateDoc(colRef, {
    ...payload,
    active: false
  });
}

export { getAllEntradas, saveEntrada, deleteEntrada, updateEntrada, filterAll, getBalanco }
